import { FC } from "react"
import { DASHBOARD_WIDGET_TYPE } from "../../api/types/Overview"
import FTModal from "../../components/common/FTModal"
import { useTranslation } from "react-i18next"
import svgIcons from "../../assets/svg/svgIcons"
import { onPrint } from "./utils/overview"
import { routeUrls } from "../../navigation/routeUrls"
import { REPORT_CATEGORIES, REPORT_TYPES } from "../../constants/constants"
import { encode as base64_encode } from "base-64";
import { useNavigate } from "react-router-dom"
import { useOverviewContext } from "./context/overview.context"
import { useLoggedInUserData } from "../../utils/user"

interface IColumnItemProps {
  widgetType: DASHBOARD_WIDGET_TYPE,
  reportId: number,
  visible: boolean,
  onHide: () => void,
  children?: React.ReactNode
}

const ModalWidgetDetails: FC<IColumnItemProps> = ({
  widgetType,
  reportId,
  visible,
  onHide,
  children,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'overviewScreen.widget_titles' });
  const navigate = useNavigate();
  const widgetLabel = t(`enum_${widgetType}`);

  const {
    timeFilter,
    allTimeFilters,
  } = useOverviewContext();

  const thisUserTimezone = useLoggedInUserData("timezone");

  const filterValues = {
    ds_time_range: allTimeFilters.find(f => f.slug === timeFilter)?.value,
    start_time: allTimeFilters.find(f => f.slug === timeFilter)?.timeRange[0] || '',
    end_time: allTimeFilters.find(f => f.slug === timeFilter)?.timeRange[1] || '',
    timezone: thisUserTimezone || '',
  };

  // prepare report filters - json encode and base64 encode
  const reportFiltersB64 = base64_encode(JSON.stringify(filterValues)).replace(/=/g, '');

  const report_page_url =
    routeUrls.dashboardChildren.reportsChildren.reportPrefix +
    routeUrls.dashboardChildren.reportsChildren.reportSuffixParamsUri
      .replace(':reportType', REPORT_TYPES.STANDARD)
      .replace(':categoryId', REPORT_CATEGORIES.OTHERS_DASHBOARD_WIDGETS)
      .replace(':reportId', reportId.toString())
      .replace(':reportFilters', reportFiltersB64);

  return (
    <FTModal
      heading={widgetLabel}
      visible={visible}
      onHide={onHide}
      containerStyle={`max-w-[calc(100vw-4rem)] w-[1200px]`}
      nodeLeftOfCloseButton={
        <>
          <button className="no-print flex p-2 me-3 bg-accent-blue-pale rounded-full group enabled:hover:bg-accent-blue-dark" onClick={onPrint}>
            <img src={svgIcons.PrintIcon} alt="print" className="size-5 group-enabled:group-hover:grayscale-0 group-enabled:group-hover:brightness-0 group-enabled:group-hover:invert" />
          </button>
          <button
            className="no-print flex p-2 me-2 bg-accent-blue-pale rounded-full group enabled:hover:bg-accent-blue-dark enabled:hover:text-white"
            onClick={() => navigate(report_page_url)}
          >
            <span className="text-sm px-1">{t('view_all_as_report')}</span>
          </button>
        </>
      }
    >
      {children}
    </FTModal>
  )
}
export default ModalWidgetDetails